<script setup lang="ts">
interface Props {
  title: string
}

defineProps<Props>()

defineOptions({
  name: 'ReferenceTitle'
})
</script>

<template>
  <h3
    class="max-h-11 min-h-0 min-w-0 overflow-hidden font-primary font-medium break-words"
  >
    {{ title }}
  </h3>
</template>
